import { render } from "./HomeSales.vue?vue&type=template&id=7096ea4c&scoped=true"
import script from "./HomeSales.vue?vue&type=script&lang=js"
export * from "./HomeSales.vue?vue&type=script&lang=js"

import "./HomeSales.vue?vue&type=style&index=0&id=7096ea4c&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7096ea4c"]])

export default __exports__